<div
    [hidden]="!active || !display()"
    class="tab-content"
    [attr.role]="'tabpanel'"
    [id]="tabId + '-tab'"
    [attr.aria-labelledby]="tabId"
    [attr.tabindex]="active && display() && focusable && shouldDisplayVerticalScrollbar ? '0' : '-1'">
    <ng-content></ng-content>
</div>
